import React from "react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#2c2c2c",
        color: "#fff",
        padding: "10px 20px",
        textAlign: "center",
        zIndex: 1000,
      }}
    >
      <p style={{ margin: 0, fontSize: "14px" }}>
        We use our own cookies to improve your experience. By continuing to use
        our site, you agree to our use of cookies. For more information, please
        see our{" "}
        <Link to="/cookie-policy" style={{ color: "#0d6efd" }}>
          Cookie Policy
        </Link>
        .
      </p>
    </div>
  );
};

export default CookieBanner;
